/**
 * The audit log page's filters and the query they become (TRA-1626).
 * Pure, so the section test can check what reaches the API.
 */

import type { AuditEvent, AuditEventParams } from '@/hooks/useAuditEvents'

import { rangeStart, type TimeRange } from './auditLabels'

/** The "no filter" choice of a dropdown. */
export const ANY = 'any'
export const PAGE_SIZE = 50
export const OUTCOMES: AuditEvent['outcome'][] = ['ok', 'denied', 'error']

export interface Filters {
  actor: string
  action: string
  outcome: string
  range: TimeRange
}

export const DEFAULT_FILTERS: Filters = { actor: '', action: ANY, outcome: ANY, range: '7d' }

/** The query the API takes for the filters and the page. */
export function auditParams(filters: Filters, cursor: string | null, now: Date): AuditEventParams {
  return {
    limit: PAGE_SIZE,
    cursor: cursor ?? undefined,
    actor: filters.actor.trim() === '' ? undefined : filters.actor.trim(),
    action: filters.action === ANY ? undefined : filters.action,
    outcome: filters.outcome === ANY ? undefined : (filters.outcome as AuditEvent['outcome']),
    from: rangeStart(filters.range, now),
  }
}
